import useApiService from "../utilities/useApiService";
import { QueryHandler } from "../network/models/QueryHandlers";
import { AxiosResponse } from "axios";
import { InfiniteListControls } from "./infiniteListTypes";
import { useInfiniteSearchList } from "./useInfiniteSearchList";

export type ProductSearchItem = {
  ndc: string;
  drugName: string;
};

const normalizeProducts = (data: unknown): ProductSearchItem[] => {
  if (Array.isArray(data)) {
    return data as ProductSearchItem[];
  }
  if (data != null && typeof data === "object") {
    return [data as ProductSearchItem];
  }
  return [];
};

type UseProductsOptions = {
  pageSize?: number;
  debounceMs?: number;
  enabled?: boolean;
};

export const useProducts = (
  manufacturer = "",
  searchTermQuery = "",
  handlers?: QueryHandler<any | undefined, AxiosResponse<any>>,
  options: UseProductsOptions = {},
): [
  ProductSearchItem[] | undefined,
  (searchTermQuery: string) => void,
  InfiniteListControls,
] => {
  const { getMethod } = useApiService();
  return useInfiniteSearchList<ProductSearchItem>({
    searchTermQuery,
    queryKey: ["/items/products", manufacturer],
    handlers,
    options,
    fetchPage: async ({ signal, pageParam, pageSize, debouncedSearchTerm }) => {
      const res = await getMethod("/items/products", {
        signal,
        params: {
          manufacturer,
          drugName: debouncedSearchTerm,
          page: pageParam,
          size: pageSize,
        },
      });
      return normalizeProducts(res.data);
    },
  });
};
